<template>
  <v-card class="tn-panel">
    <div class="tn-panel__head">
      <v-icon size="20">mdi-credit-card-outline</v-icon> Payment
      <v-spacer></v-spacer>
      <v-chip v-if="payment" small label class="tn-status-chip" :class="payment.paid ? 'tn-status-chip--success' : 'tn-status-chip--warning'">
        {{ payment.paid ? 'Paid' : 'Not paid' }}
      </v-chip>
    </div>
    <div class="tn-panel__body">
      <template v-if="hasDetails">
        <dl class="tn-facts tn-facts--stack">
          <div><dt>Amount</dt><dd>{{ money(amount) }}</dd></div>
          <div v-if="payment.result"><dt>Result</dt><dd>{{ payment.result }}</dd></div>
          <div v-if="payment.card_holder"><dt>Card holder</dt><dd>{{ payment.card_holder }}</dd></div>
          <div v-if="payment.card_number"><dt>Card</dt><dd>{{ maskCard(payment.card_number) }}</dd></div>
          <div v-if="payment.transaction_id"><dt>Transaction ID</dt><dd><copy-value :value="payment.transaction_id" label="transaction ID" /></dd></div>
          <div v-if="payment.authorization_code"><dt>Authorization code</dt><dd><copy-value :value="payment.authorization_code" label="authorization code" /></dd></div>
          <div v-if="payment.paid_at"><dt>Paid at</dt><dd>{{ dateTime(payment.paid_at) }}</dd></div>
        </dl>

        <div v-if="attempts.length" class="tn-subsection">
          <div class="tn-subsection__title">App payment attempts ({{ attempts.length }})</div>
          <ul class="tn-attempts">
            <li v-for="attempt in attempts" :key="attempt.reference">
              <span class="tn-attempts__dot" :class="'is-' + attemptTone(attempt.status)"></span>
              <div class="tn-attempts__text">
                <div class="tn-attempts__title">{{ statusLabel(attempt.status) }} · {{ money(attempt.amount, attempt.currency) }}</div>
                <div class="tn-muted">{{ dateTime(attempt.paid_at || attempt.created_at) }}<template v-if="attempt.message"> · {{ attempt.message }}</template></div>
                <div class="tn-muted tn-attempts__ref">{{ attempt.reference }}</div>
              </div>
            </li>
          </ul>
        </div>
      </template>
      <p v-else class="tn-muted mb-0">{{ emptyText }}</p>
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
import CopyValue from './CopyValue.vue'
import { formatDate, formatMoney, statusColor, statusLabel } from '../../utils/format'

export default {
  name: 'PaymentPanel',
  components: { CopyValue },
  props: {
    // overview.payment from the API: { paid, transaction_id, authorization_code, card_holder, card_number, result, paid_at, attempts[] }
    payment: { type: Object, default: null },
    amount: { type: [Number, String], default: null },
    emptyText: { type: String, default: 'No payment was recorded for this booking.' }
  },
  computed: {
    attempts () {
      return (this.payment && this.payment.attempts) || []
    },
    hasDetails () {
      const p = this.payment
      return !!(p && (p.paid || p.transaction_id || p.card_number || p.result || this.attempts.length))
    }
  },
  methods: {
    statusLabel,
    money (value, currency) {
      return formatMoney(value, currency || 'USD')
    },
    dateTime (value) {
      return formatDate(value, true)
    },
    maskCard (number) {
      const digits = String(number || '').replace(/\D/g, '')
      return digits.length >= 4 ? `•••• ${digits.slice(-4)}` : number
    },
    attemptTone (status) {
      return statusColor(status === 'failed' ? 'failed' : status)
    }
  }
}
</script>
